import { useEffect, useState } from "react";

import { filtruotiMain } from "../../functions/filtruotiMain";
import { setTabStorage, removeTabStorage } from "../../utils/tabStorage";

export const useRezultataiData = (info = [], atsakymai = []) => {
  const [visosImones, setVisosImones] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
    try {
      if (
        Array.isArray(info) &&
        Array.isArray(atsakymai) &&
        info.length > 0 &&
        atsakymai.length > 0
      ) {
        // Get unique companies that have answers
        const companiesWithAnswers = [
          ...new Set(
            atsakymai
              .map(
                (answer) =>
                  answer.attributes?.imonesPavadinimas ||
                  answer.attributes?.imones_pavadinimas
              )
              .filter(Boolean)
          ),
        ];

        // Filter and sort companies
        const filteredCompanies = info
          .map((e) => e?.imonesPavadinimas)
          .filter(Boolean)
          .filter((company) => companiesWithAnswers.includes(company))
          .sort((a, b) => a.localeCompare(b)); // Sort alphabetically

        setVisosImones(filteredCompanies);
      } else {
        setVisosImones([]);
      }
    } catch (error) {
      setVisosImones([]);
    } finally {
      setIsLoading(false);
    }
  }, [info, atsakymai]);

  return { visosImones, isLoading };
};

export const useFilteredData = (
  tipai,
  atsakymai,
  filtersMain,
  filters,
  currentYear
) => {
  const [tvarkyta, setTvarkyta] = useState([]);
  const [tvarkytaTipai, setTvarkytaTipai] = useState([]);

  // Optimizuotas filtravimas su memoizacija - sujungia abu ankstesnius useEffect į vieną efektyvesnį
  useEffect(() => {
    // Ankstyvasis išėjimas, jei neturime reikalingų duomenų
    if (!filtersMain.kasPildo || !Array.isArray(tipai) || tipai.length === 0) {
      setTvarkytaTipai([]);
      return;
    }

    // Sukuriame atributų prieigos funkciją, kuri užtikrina, kad nebūtų klaidų su undefined
    const getAttribute = (form, attrName) => {
      return (
        form?.attributes?.[attrName] ||
        form?.attributes?.[attrName.toLowerCase()]
      );
    };

    // Pirma filtruojame visus tipus pagal pagrindinius filtrus
    const filteredForms = tipai.filter((form) => {
      // Tikrinama ar forma atitinka kasPildo
      const formType = getAttribute(form, "kasPildo");
      if (formType !== filtersMain.kasPildo) return false;

      // // Tikrinama ar forma atitinka metus, jei jie pasirinkti
      // if (currentYear !== undefined && currentYear !== null) {
      //     const validToString = getAttribute(form, 'validTo') || getAttribute(form, 'valid_to');
      //     if (!validToString) return false;

      //     const formYear = new Date(validToString).getFullYear();
      //     if (formYear !== currentYear) return false;
      // }

      // Tikrinama ar forma atitinka įmonę, jei ji pasirinkta
      if (
        filtersMain.imonesPavadinimas &&
        filtersMain.kasPildo === "Darbuotojo forma"
      ) {
        const formCompany = getAttribute(form, "imonesPavadinimas");
        if (formCompany && formCompany !== filtersMain.imonesPavadinimas)
          return false;
      }

      // Jei visos sąlygos tenkina, forma įtraukiama
      return true;
    });

    // Išrenkame unikalius tipus pagal formos pavadinimą
    const uniqueFormTypes = filteredForms.reduce((unique, form) => {
      const formName = getAttribute(form, "formosPavadinimas");
      const existing = unique.find(
        (f) => getAttribute(f, "formosPavadinimas") === formName
      );

      if (!existing) {
        unique.push(form);
      }

      return unique;
    }, []);

    setTvarkytaTipai(uniqueFormTypes);
  }, [tipai, filtersMain.kasPildo, filtersMain.imonesPavadinimas, currentYear]);

  // Filtruojame atsakymus pagal visus filtrus
  useEffect(() => {
    // Ankstyvasis išėjimas, jei neturime filtrų
    if (Object.keys(filtersMain).length === 0) {
      setTvarkyta([]);
      return;
    }

    // Tikriname ar atsakymai yra validūs
    if (
      !atsakymai ||
      (!Array.isArray(atsakymai) && typeof atsakymai !== "object")
    ) {
      setTvarkyta([]);
      return;
    }

    // Naudojame optimizuotą filtravimo funkciją
    try {
      filtruotiMain(atsakymai, filtersMain, setTvarkyta, currentYear, filters);
    } catch (error) {
      console.error("Klaida filtruojant atsakymus:", error);
      setTvarkyta([]);
    }
  }, [atsakymai, filtersMain, filters, currentYear]);

  return {
    tvarkyta,
    tvarkytaTipai,
  };
};

export const useYearManagement = (yearOptions, currentYear, setYear) => {
  useEffect(() => {
    // Only reset year if there are no options AND no current year
    if (yearOptions.length === 0 && !currentYear) {
      setYear(undefined);
      removeTabStorage("currentYear");
      return;
    }

    // If we have a current year but it's not in the options,
    // keep it unless we have better options
    if (currentYear && !yearOptions.includes(currentYear)) {
      if (yearOptions.length > 0) {
        const newYear = yearOptions[0]; // yearOptions are sorted in descending order
        setYear(newYear);
        setTabStorage("currentYear", newYear.toString());
      }
      // If no options available, keep the current year
      return;
    }

    // If no current year but we have options, select the most recent
    if (!currentYear && yearOptions.length > 0) {
      const newYear = yearOptions[0];
      setYear(newYear);
      setTabStorage("currentYear", newYear.toString());
    }
  }, [yearOptions, currentYear, setYear]);
};
